module.exports = __webpack_public_path__ + "img/account-archive-book.90def476.svg";